import { store } from "@/app/store";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router";
import { v4 as uuidv4 } from 'uuid';
import clarity from '@microsoft/clarity';
import App from "./App";

// Initialize Microsoft Clarity for session tracking
const initializeClarity = () => {
  const msClarityProjectID = import.meta.env.VITE_MS_CLARITY_PROJECT_ID;
  if (msClarityProjectID) {
    // Initialize Clarity with the project ID
    clarity.init(msClarityProjectID);
    // Get user email from localStorage
    const email = localStorage.getItem('email') ?? '';
    const surveyId = localStorage.getItem('surveyId') ?? '';
    // Identify user with session tracking
    clarity.identify(uuidv4(), surveyId, 'siteiq-page-id', email);
  } else {
    console.warn('MS Clarity Project ID is undefined. Skipping Clarity initialization.');
  }
};
// Initialize Clarity before rendering the app
initializeClarity();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </StrictMode>,
);
